/*!
 * ymm-garage.js — the active-vehicle store (localStorage + mirror cookie + change event).
 * Loads early (before sections paint) so the header bar / badges know the vehicle with no flicker.
 * window.YMMGarage: get() set(veh) clear() list() remove(label). Fires document 'ymm:garage'.
 * Port of hogplay-dotcom/public/assets/js/hp-garage.js — client-side only (Shopify caches pages).
 */
(function (w) {
  'use strict';
  var ACTIVE = 'ymm_active', RECENT = 'ymm_garage', MAX = 5;
  function read(k) { try { return JSON.parse(w.localStorage.getItem(k)); } catch (e) { return null; } }
  function write(k, v) { try { w.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function cookie(veh) {
    try {
      var maxAge = veh ? 60 * 86400 : 0;
      w.document.cookie = 'hp_veh=' + encodeURIComponent(veh ? JSON.stringify(veh) : '') +
        ';path=/;max-age=' + maxAge + ';SameSite=Lax';
    } catch (e) {}
  }
  var G = w.YMMGarage = {
    get: function () { return read(ACTIVE); },
    list: function () { return read(RECENT) || []; },
    set: function (veh) {
      if (!veh) return;
      write(ACTIVE, veh); cookie(veh);
      var l = (read(RECENT) || []).filter(function (v) { return v && v.label !== veh.label; });
      l.unshift(veh); write(RECENT, l.slice(0, MAX));
      G.emit();
    },
    clear: function () { write(ACTIVE, null); cookie(null); G.emit(); },
    remove: function (label) {
      write(RECENT, (read(RECENT) || []).filter(function (v) { return v && v.label !== label; }));
      G.emit();
    },
    emit: function () {
      try { w.document.dispatchEvent(new CustomEvent('ymm:garage', { detail: G.get() })); } catch (e) {}
    },
  };
})(window);
